import { render, staticRenderFns } from "./formConfig.vue?vue&type=template&id=31914a1e&scoped=true&"
import script from "./formConfig.vue?vue&type=script&lang=js&"
export * from "./formConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31914a1e",
  null
  
)

export default component.exports